/* Viva La Vulva — cart attribute saving
 *
 * Saves the cart questions ("How did you hear about us", "Is this a gift",
 * "Is this for non-pregnancy-related care") the moment a customer answers them.
 *
 * Background: these fields exist TWICE in the theme.
 *   snippets/cart-footer.liquid  renders them on the cart page
 *   snippets/cart-items.liquid   renders them in the cart drawer, every page
 * The old saving code lived inside cart-footer and never executed, because its
 * script tag sat in markup the theme injects into the page and browsers do not
 * run scripts inserted that way. Every answer given before this file existed
 * was lost — confirmed against 25 consecutive orders, all three fields empty.
 *
 * Rather than rewrite both copies, this listens for either shape:
 *   data-cart-attribute="Key"      (the rewritten cart-footer markup)
 *   name="attributes[Key]"         (the original markup, still in cart-items)
 *
 * Loaded from snippets/js-bridge.liquid, which layout/theme.liquid renders on
 * every page, so it covers the drawer as well as the cart page.
 */
(function () {
  // Shopify's cart is a single object and concurrent writes can clobber each
  // other — confirmed by test: two updates fired together lost one. Every save
  // goes through this queue so only one is ever in flight.
  var queue = Promise.resolve();

  function enqueue(task) {
    queue = queue.then(task, task);
    return queue;
  }

  function keyFor(el) {
    var explicit = el.getAttribute('data-cart-attribute');
    if (explicit) return explicit;
    var name = el.getAttribute('name') || '';
    var m = name.match(/^attributes\[(.+)\]$/);
    return m ? m[1] : null;
  }

  function save(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.tagName) return;
    if (!/^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName)) return;

    var key = keyFor(el);
    if (!key) return;

    var value = el.type === 'checkbox' ? (el.checked ? 'Yes' : 'No') : el.value;
    var attrs = {};
    attrs[key] = value;

    enqueue(function () {
      return save(attrs)
        .then(function () {
          // These fields render more than once per page (drawer + cart page).
          // Keep every copy in step so a customer never sees their answer
          // appear to reset itself.
          var candidates = document.querySelectorAll('[data-cart-attribute], [name^="attributes["]');
          Array.prototype.forEach.call(candidates, function (other) {
            if (other === el || keyFor(other) !== key) return;
            if (other.type === 'checkbox') {
              other.checked = el.checked;
            } else {
              other.value = el.value;
            }
          });
        })
        .catch(function (err) {
          // Log rather than swallow. The code this replaces had its only error
          // line commented out, so failures were completely invisible.
          console.warn('[VLV] Could not save cart attribute "' + key + '":', err);
        });
    });
  });
})();
